var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { useContext } from "react";
import { PageLayoutsContext } from "../components/context/page-layouts-context";
export var usePageLayouts = function usePageLayouts() {
  var custom = useContext(PageLayoutsContext) || {}; // eventually, we may re-introduce defaults, so leave this superfluous code here :)

  return __assign({}, custom);
};